import React, { useCallback, useState, useMemo  } from 'react';
import { FieldArray } from 'formik';
import { Box, Button, Collapse, Typography, Paper } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ProdcutPriceModalContainer from '../../../containers/chancemng/costcalc/ProdcutPriceModalContainer';
import CostCalcForm from './CostCalcForm';
import PartnerModalConatiner from '../../../containers/common/form/modal/PartnerModalConatiner';
import ChanceCostCalcUploadDialog from '../../../containers/chancemng/ChanceCostCalcUploadDialog';
import { useBoolean } from '../../../hooks/useBoolean';
import { maxWidth, minWidth, width } from '../../../../node_modules/@mui/system/index';
import { getNumberComma } from '../../../utils/numberUtils';
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const CostCalcListForm = ({
  formik,
  ArrayHelperRef,
  itemCdOptions,
  selectedVendor,
  onSelectedProducts,
  onAddEtcProduct,
}) => {
  const classes = useStyles();

  const [openProduct, setOpenProduct] = useState(false);
  const handleOpenProduct = () => {
    setOpenProduct(true);
  };
  const handleCloseProduct = () => {
    setOpenProduct(false);
  };
  const [showGuide, setShowGuide] = useState(false);
  const [selectedFormIndex, setSelectedFormIndex] = useState(null);
  const [openParnter, setOpenParnter] = useState(false);
  const handleOpen = (index) => {
    setOpenParnter(true);
    setSelectedFormIndex(index);
  };
  const handleClose = () => {
    setOpenParnter(false);
    setSelectedFormIndex(null);
  };

  const selectedPartner = (partner) => {
    formik.setFieldValue(
      `costCalcs[${selectedFormIndex}].sellPartnerUuid`,
      partner.partnerUuid,
    );
    formik.setFieldValue(
      `costCalcs[${selectedFormIndex}].sellPartnerNm`,
      partner.partnerNm,
    );
  };

  const showUpload = useBoolean();
  const handleUpload = useCallback(() => {
    showUpload.onTrue();
  }, [showUpload]);

  const handleDownload = () => {
    const url = `resource/cost_excel.xlsx`;
    fetch(url, { method: 'GET' })
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = '원가산출_업로드용_엑셀';
        document.body.appendChild(a);
        a.click();
        setTimeout((_) => {
          window.URL.revokeObjectURL(url);
        }, 60000);
        a.remove();
      })
      .catch((err) => {
        console.error('err: ', err);
      });
  };

  const refreshOnClose = (data) => {
    // console.log(data, 'data');
    // eslint-disable-next-line array-callback-return
    data.map((item) => {
      ArrayHelperRef.current.push({
        masterTyp: 'E',
        priceUuid: item?.priceUuid,
        sellPartnerUuid: '',
        sellPartnerNm: '(주)에이치씨인포',
        partnerUuid: item?.partnerUuid,
        partnerNm: item?.partnerNm,
        productNm: item?.productNm,
        productUuid: item?.productUuid,
        expCnt: item?.expCnt,
        unitVal: item?.unitVal,
        unitValIn: item?.unitValIn,
        priceVal: item?.priceVal,
        priceValIn: item?.priceValIn,
        saleVal: item?.saleVal,
        saleValIn: item?.saleValIn,
        buyVal: item?.buyVal,
        profit: item?.salePct,
        profitIn: item?.salePctIn,
        profitRate: item?.saleProfit,
        profitRateIn: item?.saleProfitIn,
        productDesc: item?.productDesc,
        productUnit: item?.productUnit,
        itemCd: '기타',
      });
    });

    showUpload.onFalse();
  };
  const computedDataList = useMemo(() => {
    return formik.values.costCalcs?.map((item) => {
      const calcExVat = (val) => Math.trunc((val / 1.1) + 0.0001);
      const calcVatIn = (val) => Math.trunc((val * 1.1) + 0.0001);

      // [최종 수정] 금액 조정 행: 역산 없이 입력된 숫자를 그대로 독립적으로 사용
        const isAdj = item.isAdjustment || item.masterTyp === 'BAL';

      if (isAdj) {
        const sVal = Number(item.saleVal) || 0;
        const sValIn = Number(item.saleValIn) || 0;
        const bVal = Number(item.buyVal) || 0;
        const bValIn = Number(item.priceValIn) || 0;

        const profit = sVal - bVal;

        return {
          ...item,
          isAdjustment: true, // 다시 로드된 데이터에도 플래그를 주입해줌
          unitVal: 0,
          saleVal: sVal,
          saleValIn: sValIn,
          priceVal: 0,
          buyVal: bVal,
          priceValIn: bValIn,
          profit,
          profitRate: sVal !== 0 ? (profit / sVal) * 100 : 0
        };
      }

      // --- 기존 일반 행 계산 로직 (유지) ---
      const sType = item.salesType || 'unitVal';
      const pType = item.purchaseType || 'priceVal';
      const count = Number(item.expCnt) || 0;
      
      let uVal = Number(item.unitVal) || 0;
      let sVal = Number(item.saleVal) || 0;
      let sValIn = Number(item.saleValIn) || 0;
      let pVal = Number(item.priceVal) || 0;
      let bVal = Number(item.buyVal) || 0;
      let pValIn = Number(item.priceValIn) || 0;

      if (sType === 'unitVal') {
        sVal = uVal * count;
        sValIn = calcVatIn(sVal);
      } else if (sType === 'saleVal') {
        uVal = count > 0 ? Math.round(sVal / count) : 0;
        sValIn = calcVatIn(sVal);
      } else if (sType === 'saleValIn') {
        sVal = calcExVat(sValIn);
        uVal = count > 0 ? Math.round(sVal / count) : 0;
      }

      if (pType === 'priceVal') {
        bVal = pVal * count;
        pValIn = calcVatIn(bVal);
      } else if (pType === 'buyVal') {        
        pVal = count > 0 ? Math.round(bVal / count) : 0;
        pValIn = calcVatIn(bVal);
      } else if (pType === 'priceValIn') {
        bVal = calcExVat(pValIn);
        pVal = count > 0 ? Math.round(bVal / count) : 0;
      }

      const profit = sVal - bVal;

      return {
        ...item,
        unitVal: uVal,
        saleVal: sVal,
        saleValIn: sValIn,
        priceVal: pVal,
        buyVal: bVal,
        priceValIn: pValIn,
        profit,
        profitRate: sVal !== 0 ? (profit / sVal) * 100 : 0
      };
    });
  }, [formik.values.costCalcs]);

  return (
    <div>
      <FieldArray
        name="costCalcs"
        render={(arrayHelpers) => {
          ArrayHelperRef.current = arrayHelpers;
          return (
            <Box>
              {!formik.values?.costCalcs ||
              formik.values?.costCalcs?.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography variant="subtitle2" component="div">
                    원가 산출 내역이 없습니다. 제품을 선택하여 원가 산출을
                    등록하세요.
                  </Typography>
                </Box>
              ) : (
                <>
                <Paper variant="outlined" sx={{ mb: 2, bgcolor: '#f9f9f9', overflow: 'hidden' }}>
                  <Button
                    fullWidth
                    onClick={() => setShowGuide(!showGuide)}
                    startIcon={<HelpOutlineIcon sx={{ color: 'secondary.main' }} />}
                    endIcon={showGuide ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    sx={{
                      justifyContent: 'space-between',
                      px: 2,
                      py: 1,
                      color: '#555',
                      fontWeight: 700,
                      '&:hover': { bgcolor: '#f0f0f0' }
                    }}
                  >
                    원가 계산서 작성 및 금액 조정 방법
                  </Button>
                  
                  <Collapse in={showGuide}>
                    <Box sx={{ p: 2, pt: 0, borderTop: '1px solid #e0e0e0' }}>
                      <Typography variant="body2" component="div" sx={{ color: '#666', lineHeight: 1.8 }}>
                        • <b>품목 추가:</b> 상단의 상품 검색으로 규격 상품을 추가하거나, '기타 품목'으로 수동 입력이 가능합니다.<br />
                        
                        • <b>가격 조정:</b> 아래 항목 중 하나를 클릭하면 <span style={{ backgroundColor: '#fff9c4', padding: '0 2px' }}>노란색</span>으로 활성화되며, 해당 값을 기준으로 나머지 금액이 자동 계산됩니다.
                          <Box sx={{ ml: 2, mt: 0.5, color: '#444', fontSize: '0.8rem', bgcolor: '#f0f0f0', p: 1, borderRadius: 1 }}>
                            - 매출: 매출단가(VAT별도), 매출금액(VAT별도), 매출금액(VAT포함)<br />
                            - 매입: 매입단가(VAT별도), 매입금액(VAT별도), 매입금액(VAT포함)
                          </Box>

                        • <b>수량 변동:</b> 수량을 변경하면 현재 선택된 <b>기준 값(노란색 칸)</b>은 고정됩니다.
                          <Box sx={{ ml: 2, mt: 0.5, color: '#444', fontSize: '0.8rem' }}>
                            - <b>단가</b>가 기준일 때: 수량 증감에 따라 최종 매출/매입 금액이 자동으로 증감합니다.<br />
                            - <b>금액</b>이 기준일 때: 최종 금액을 유지하기 위해 <b>단가</b>가 자동으로 역산되어 변경됩니다.
                          </Box>

                        • <b>부가세(VAT) 안내:</b> <b>VAT포함</b> 금액은 전체 규모 확인을 위한 <b>참고용</b>입니다. 실제 계산서 작성 및 부가세 산정은 <b>매출 및 매입 VAT별도</b> 가격을 기준으로 진행됩니다.<br />

                        • <b>금액 조정:</b> 매입처 소계 행의 <b>[금액 조정]</b> 버튼을 누르면 단가/수량과 무관한 최종 금액 보정 행이 추가됩니다. (단가/수량 입력 불가, <b>최종 합계 금액</b>만 수정 가능)<br />

                        • <b>소계 및 합계:</b> 모든 금액은 실시간으로 합산되며, 단수 차이 발생 시 조정 행을 통해 최종 금액을 맞추시기 바랍니다.
                      </Typography>
                    </Box>
                  </Collapse>
                </Paper>
                <TableContainer
                  size="small"
                  className={classes.table}
                >
                  <Table padding="none" sx={{ tableLayout: 'fixed', width: '100%' }}>
                     <colgroup>
                        <col style={{ width: '40px' }} />
                        <col style={{ width: '270px' }} />
                        <col style={{ width: '40px' }} />
                        <col style={{ width: '40px' }} />
                        <col style={{ width: '40px' }} />
                        <col style={{ width: '120px' }} />
                        <col style={{ width: '120px' }} />
                        <col style={{ width: '120px' }} />
                        <col style={{ width: '120px' }} />
                        <col style={{ width: '120px' }} />
                        <col style={{ width: '120px' }} />
                        <col style={{ width: '110px' }} /> 
                        <col style={{ width: '70px' }} />  
                        <col style={{ width: '60px' }} />
                        <col style={{ width: '150px' }} />
                        <col style={{ width: '40px' }} /> 
                      </colgroup>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">No</TableCell>
                        <TableCell sx={{ width: 280, minWidth: 280, maxWidth: 280 }} rowSpan={2} align="center">매출내용(제품 또는 용역명)</TableCell>
                        <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">사양</TableCell>
                        <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">수량</TableCell>
                        <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">단위</TableCell>

                        <TableCell colSpan={3} align="center">매출</TableCell>
                        <TableCell colSpan={3} align="center">매입</TableCell>
                        <TableCell sx={{ width: 130, minWidth: 130, maxWidth: 130 }} colSpan={2} align="center">매출이익</TableCell>

                        <TableCell sx={{ width: 60, minWidth: 60, maxWidth: 60 }} rowSpan={2} align="center">아이템</TableCell>
                        <TableCell sx={{ width: 140, minWidth: 140, maxWidth: 140 }} rowSpan={2} align="center">매입처</TableCell>
                        <TableCell sx={{ width: 40, minWidth: 40, maxWidth: 40 }} rowSpan={2} align="center">삭제</TableCell>
                      </TableRow>

                      <TableRow>
                      {/* 매출 & 매입 그룹 매핑 */}
                      {[
                        { label1: '매출단가', label2: '(VAT별도)', key: 'unitVal', bg: 'inherit', group: 'globalSalesType', defaultKey: 'unitVal' },
                        { label1: '매출금액', label2: '(VAT별도)', key: 'saleVal', bg: '#f8f8f8', group: 'globalSalesType', defaultKey: 'unitVal' },
                        { label1: '매출금액', label2: '(VAT포함)', key: 'saleValIn', bg: '#f8f8f8', group: 'globalSalesType', defaultKey: 'unitVal' },
                        { label1: '매입단가', label2: '(VAT별도)', key: 'priceVal', bg: 'inherit', group: 'globalPurchaseType', defaultKey: 'priceVal' },
                        { label1: '매입금액', label2: '(VAT별도)', key: 'buyVal', bg: '#f8f8f8', group: 'globalPurchaseType', defaultKey: 'priceVal' },
                        { label1: '매입금액', label2: '(VAT포함)', key: 'priceValIn', bg: '#f8f8f8', group: 'globalPurchaseType', defaultKey: 'priceVal' },
                      ].map((item) => {
                        // 현재 포커스/입력에 의해 결정된 기준값인지 확인
                        const isSelected = formik.values[item.group] 
                          ? formik.values[item.group] === item.key 
                          : item.key === item.defaultKey;

                        return (
                          <TableCell 
                            key={item.key} 
                            align="center" 
                            sx={{ 
                              // [핵심] 선택된 기준 컬럼은 배경색을 연한 노란색으로 강조 (본문의 하이라이트와 통일)
                              backgroundColor: item.bg, 
                              p: '12px 4px !important', 
                              position: 'relative',
                              verticalAlign: 'middle',
                              borderLeft: item.key === 'priceVal' ? '1px solid #e0e0e0' : 'none',
                              transition: 'background-color 0.2s' // 부드러운 전환 효과
                            }}
                          >
                            <Typography sx={{ 
                              fontSize: '0.875rem', 
                              lineHeight: 1.3, 
                              fontWeight: isSelected ? 800 : 600, // 선택된 기준은 폰트 두께 더 강조
                              whiteSpace: 'nowrap',
                              textAlign: 'center',
                              color: '#333' // 선택된 기준은 텍스트 색상 변경 (파란색 계열)
                            }}>
                              {item.label1}<br/>{item.label2}
                            </Typography>
                          </TableCell>
                        );
                      })}

                      <TableCell sx={{ width: 160, minWidth: 160, maxWidth: 160, fontSize: '0.875rem' }} align="center">매출이익<br/>(VAT별도)</TableCell>
                      <TableCell sx={{  width: 30, minWidth: 30, maxWidth: 30, backgroundColor: '#f5f4f4', fontSize: '0.875rem' }} align="center">이익율</TableCell>
                    </TableRow>

                    </TableHead>
                   <TableBody>
                    {computedDataList?.map((computedData, index, array) => {
                      const rows = [];

                      // 1. 메인 데이터 행 추가
                      rows.push(
                        <CostCalcForm
                          key={computedData.id || `row-${index}`}
                          index={index}
                          formik={formik}
                          cost={computedData}
                          itemCdOptions={itemCdOptions}
                          handleOpen={handleOpen}
                          handleRemove={() => {
                            if (ArrayHelperRef.current) ArrayHelperRef.current.remove(index);
                          }}
                        />
                      );

                      // 2. 소계 행 삽입 로직
                      const nextItem = array[index + 1];
                      if (!nextItem || computedData.sellPartnerUuid !== nextItem.sellPartnerUuid) {
                        
                        const partnerRows = array.filter(item => item.sellPartnerUuid === computedData.sellPartnerUuid);
                        
                        // [체크] 현재 파트너 그룹 내에 이미 BAL 타입(금액 조정)이 있는지 확인
                        const hasAdjustment = partnerRows.some(item => item.masterTyp === 'BAL' || item.isAdjustment);

                        const subTotalSale = partnerRows.reduce((sum, item) => sum + (item.saleVal || 0), 0);
                        const subTotalSaleIn = partnerRows.reduce((sum, item) => sum + (item.saleValIn || 0), 0);
                        const subTotalBuy = partnerRows.reduce((sum, item) => sum + (item.buyVal || 0), 0);
                        const subTotalBuyIn = partnerRows.reduce((sum, item) => sum + (item.priceValIn || 0), 0);
                        const subTotalProfit = subTotalSale - subTotalBuy;

                        rows.push(
                          <TableRow key={`subtotal-${index}`} sx={{ backgroundColor: '#e0e0e0', height: '32px' }}>
                            <TableCell colSpan={5} align="right" sx={{ fontWeight: 800, fontSize: '0.85rem', pr: 2 }}>
                              {computedData.sellPartnerNm || '기타'} 소계 :
                            </TableCell>

                            <TableCell />
                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: '0.85rem', pr: '4px !important' }}>
                              {getNumberComma(subTotalSale)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: '0.85rem', pr: '4px !important'}}>
                              {getNumberComma(subTotalSaleIn)} 
                            </TableCell>

                            <TableCell />
                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: '0.85rem', pr: '4px !important' }}>
                              {getNumberComma(subTotalBuy)}
                            </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: '0.85rem', pr: '4px !important'}}>
                              {getNumberComma(subTotalBuyIn)}
                            </TableCell>

                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: '0.85rem', pr: '4px !important' }}>
                              {getNumberComma(subTotalProfit)}
                            </TableCell>

                            <TableCell align="center" sx={{ fontWeight: 600, fontSize: '0.875rem'}}>
                              {subTotalSale !== 0 ? ((subTotalProfit / subTotalSale) * 100).toFixed(2) : '0.00'}%
                            </TableCell>

                            <TableCell colSpan={3} align="center">
                              <Button 
                                variant="contained" 
                                size="small" 
                                color="secondary"
                                // [수정] 이미 조정 행이 있으면 비활성화
                                disabled={hasAdjustment}
                                sx={{ height: '24px', fontSize: '0.7rem' }}
                                onClick={() => {
                                  if (ArrayHelperRef.current) {
                                    ArrayHelperRef.current.insert(index + 1, {
                                      isAdjustment: true,
                                      masterTyp: 'BAL',
                                      itemCd: '',
                                      productNm: '금액 조정',
                                      sellPartnerUuid: computedData.sellPartnerUuid,
                                      sellPartnerNm: computedData.sellPartnerNm,
                                      partnerUuid: '',
                                      partnerNm: '',
                                      expCnt: 1,
                                      unitVal: 0,
                                      unitValIn: 0,
                                      productUnit: '',
                                      priceVal: 0,
                                      priceValIn: 0,
                                      saleVal: 0,
                                      saleValIn: 0,
                                      buyVal: 0,
                                      profit: 0,
                                      profitIn: 0,
                                      profitRate: 0,
                                      profitRateIn: 0,
                                      productDesc: '단수 차이 등 금액 조정용 행',
                                      salesType: 'saleVal',
                                      purchaseType: 'buyVal'
                                    });
                                  }
                                }}
                              >
                                금액 조정
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      }
                      return <React.Fragment key={`group-${index}`}>{rows}</React.Fragment>;
                    })}



                    {/* 전체 합계 행 (제공하신 코드 그대로 유지) */}
                    {computedDataList?.length > 0 && (() => {
                      const totalSale = computedDataList.reduce((sum, item) => sum + (item.saleVal || 0), 0);
                      const totalBuy = computedDataList.reduce((sum, item) => sum + (item.buyVal || 0), 0);
                      const totalSaleVat = computedDataList.reduce((sum, item) => sum + (item.saleValIn || 0), 0);
                      const totalBuyVat = computedDataList.reduce((sum, item) => sum + (item.priceValIn || 0), 0);
                      const totalProfit = totalSale - totalBuy;

                      return (
                        <TableRow sx={{ backgroundColor: '#e3f2fd', height: '35px' }}>
                          <TableCell colSpan={5} align="right" sx={{ fontWeight: 900, fontSize: '0.85rem', pr: 2 }}>합계 :</TableCell>
                          <TableCell />
                          <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>{getNumberComma(totalSale)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>{getNumberComma(totalSaleVat)}</TableCell>
                          <TableCell />
                          <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>{getNumberComma(totalBuy)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 800, fontSize: '0.9rem', pr: '4px !important', color: '#01579b' }}>{getNumberComma(totalBuyVat)}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 900, fontSize: '0.9rem', color: '#01579b', pr: '4px !important' }}>{getNumberComma(totalProfit)}</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 800, fontSize: '0.9rem', color: '#01579b'}}>{totalSale !== 0 ? ((totalProfit / totalSale) * 100).toFixed(2) : '0.00'}%</TableCell>
                          <TableCell colSpan={3} />
                        </TableRow>
                      );
                    })()}
                  </TableBody>
                  </Table>
                </TableContainer>
                </>
              )}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  mt: 2,
                }}
              >
                <Box sx={{ mx: 1 }}>
                  <Button
                    color="warning"
                    variant="outlined"
                    onClick={onAddEtcProduct}
                  >
                    기타 제품 추가
                  </Button>
                </Box>

                <Box sx={{ mx: 1 }}>
                  <Button
                    color="secondary"
                    variant="outlined"
                    onClick={handleOpenProduct}
                  >
                    제품 추가
                  </Button>
                </Box>
                <Box sx={{ mx: 1 }}>
                  <Button
                    color="success"
                    variant="outlined"
                    onClick={handleDownload}
                  >
                    제품 엑셀 템플릿 다운로드
                  </Button>
                </Box>

                <Box sx={{ mx: 1 }}>
                  <Button
                    color="info"
                    variant="outlined"
                    onClick={handleUpload}
                  >
                    제품 엑셀 엡로드
                  </Button>
                </Box>
              </Box>
            </Box>
          );
        }}
      ></FieldArray>
      <Box>
        <ProdcutPriceModalContainer
          title="원가 산출 제품 선택"
          open={openProduct}
          handleClose={handleCloseProduct}
          onSelectedProducts={onSelectedProducts}
          selectedPartner={selectedVendor}
        />
        {openParnter && (
          <PartnerModalConatiner
            link
            title="매출처 선택"
            open={openParnter}
            handleClose={handleClose}
            selectedPartner={selectedPartner}
          />
        )}
        <ChanceCostCalcUploadDialog
          title="원가산출 엑셀 업로드"
          open={showUpload.value}
          onClose={() => {
            showUpload.onFalse();
          }}
          refreshOnClose={refreshOnClose}
        />
      </Box>
    </div>
  );
};

export default CostCalcListForm;
